import config from "../../../../store/sqftConfig";
import {isIE} from "../../../../../../helpers/sqftHelper";

export default class DrawImage {

  static renderImage = (svgImageId, ctx, x, y, width, height, isCentered = true, isScale = true) => {
    let scale = config.scale;
    let svg = document.getElementById(svgImageId);
    if (!svg) {
      console.error("svg with id not found", svgImageId);
      return
    }
    let img = new Image(),
      xml = new XMLSerializer().serializeToString(svg), // get svg data
      svg64 = btoa(xml); // make it base64
    let posX = x;
    let posY = y;
    let svgImageDataURI = "";

    img.src = 'data:image/svg+xml;base64,' + svg64; // set it as the source of the img element
    if (isScale) {
      width = width / config.scale * config.defaultScale;
      height = height / config.scale * config.defaultScale;
    }
    if (isCentered) {
      posX -= width / 2 ;
      posY -= height / 2;
    }

    if (isIE()) {
      svgImageDataURI = atob(this.getSrc(img).replace(/data:image\/svg\+xml;base64,/, ''));
    }
    if (!isIE()) {
      ctx.drawImage(img,  posX, posY , width * scale, height * scale);
    } else if(svgImageDataURI) {
      ctx.drawSvg(svgImageDataURI, posX, posY + 1, 0, 0);
    }
  };

  // static isIE() {
  //   return(/Trident/i).test(window.navigator.appVersion);
  // }

  static getSrc(htmlImg) {
    if (htmlImg) {
      let src = htmlImg.getAttribute('src');
      if (src) return src;

      const style = htmlImg.getAttribute("style");
      if (style) {
        return style
          .replace(/background-image: url\("\/api\/SqFtCalc\/GetImage\?url=/g, "")
          .replace(/"\);/g, "");
      }
    }
    return "";
  }
}
